export const isCustomErrorCheck = (error) => typeof error === "object" &&
    error !== null &&
    (("message" in error && typeof error.message === "string") ||
        ("statusCode" in error && typeof error.statusCode === "number"));
//# sourceMappingURL=isCustomErrorCheck.js.map